export default "<label class=\"switch\">\n  <input class=\"checkbox\" type=\"checkbox\" />\n  <span class=\"slider round\"></span>\n</label>\n";